import { useQuery, useReactiveVar } from '@apollo/client'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

import { LANExposureArea } from '@web/components/LANBanner/LANBanner.constant'
import { gql } from '@web/gql'
import { LanBanner_LineAppNotificationFragment } from '@web/gql/graphql'
import { extractByTypename } from '@web/libs/apollo/typeGuard'

import { darkModeVar } from './useGlobalDetermineDarkMode'

dayjs.extend(isBetween)

const fragment = gql(`
  fragment LineAppNotifications_Query on Query {
    lineAppNotifications {
      __typename
      ... on LineAppNotificationsSuccess {
        lineAppNotifications {
          ...LANBanner_LineAppNotification
        }
      }
    }
  }

  fragment LANBanner_LineAppNotification on LineAppNotification {
    id
    title
    openDateTime
    closeDateTime
    contentUrl
    linkUrl
    exposureArea
    description
    bgColor {
      r
      g
      b
    }
    clickCode
  }
`)

export const LineAppNotificationsQuery = gql(`
  query LineAppNotifications {
    ...LineAppNotifications_Query
  }
`)

const useGetExposureNotifications = (
  exposureArea: LANExposureArea,
): { notifications: LanBanner_LineAppNotificationFragment[]; loading: boolean } => {
  const { data, loading } = useQuery(LineAppNotificationsQuery)

  const dark = useReactiveVar(darkModeVar)

  const { LineAppNotificationsSuccess } = extractByTypename(data?.lineAppNotifications)
  if (!LineAppNotificationsSuccess) {
    return {
      notifications: [],
      loading,
    }
  }

  const { lineAppNotifications } = LineAppNotificationsSuccess

  return {
    loading,
    notifications: lineAppNotifications.filter(
      lan =>
        (dark ? lan.exposureArea === `${exposureArea}_dark` : lan.exposureArea === exposureArea) &&
        dayjs().isBetween(dayjs(lan.openDateTime), dayjs(lan.closeDateTime), undefined, '(]'),
    ),
  }
}

export default useGetExposureNotifications
